import React, { useState, useEffect } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { TextField, Button } from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import EmailConfirmation from "./EmailConfirmation";
import LocalIP from "../../api/LocalIP";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);

  const validateEmail = (value) => {
    if (value.length === 0) {
      toast.error("Please enter the e-mail address.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmailValid = validateEmail(email);
    if (isEmailValid) {
      try {
        const { data } = await axios.post(LocalIP + "/user/forgotPassword", { email });
        if (data.responseCode === "SUCCESS") {
          //setEmail("");
          toast.success("Password reset link has been sent to your e-mail");
          setIsSubmit(true);
          //navigate('/')
        }
      } catch (err) {
        console.log(err);

        if (err.response && err.response.data && err.response.data.message) {
          toast.error("Please enter a valid e-mail address.");
        } else {
          toast.error(err.response.data.message);
        }
      }
    }
  };

  return isSubmit ? (
    <EmailConfirmation email={email} />
  ) : (
    <div
      className='grid grid-cols-1 lg:grid-cols-2 min-h-screen font-inter'
      style={{
        background: 'linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)',
        backgroundColor: 'rgb(23,39,92)'
      }}>
      <div className='hidden lg:flex items-center justify-center text-3xl text-white p-4'>{/* Left content for larger screens */}</div>

      <div className='flex items-center justify-center px-6 py-8 lg:py-0 bg-red lg:border-l-2' style={{ borderColor: '#214471' }}>
        <div className='w-full max-w-md bg-white p-6 rounded-lg shadow-md'>

            <Link to={"/"}>
              <div className="bg-blue-950 w-7 h-7 rounded flex justify-center items-center ml-10 mt-6">
                <IoChevronBackOutline
                  style={{ color: "white", fontSize: "1.5rem" }}
                />
              </div>
            </Link>

            <div className="text-center mt-6">
              <h1 className="text-black font-bold text-xl ml-10 mb-1 text-left">
                Forgot Password
              </h1>
              <p
                className="text-base px-20 ml-6 mt-6 mb-6 text-left"
                style={{ paddingLeft: "1rem" }}
              >
                Enter the email associated with your account and we’ll send an
                email with instructions to reset your password.
              </p>
            </div>

            <form
              className="flex flex-col ml-10 w-full"
              style={{ marginTop: "2rem" }}
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col mb-4">
                <label className="text-black mb-1 text-base font-medium text-left">
                  Email
                </label>

                <TextField
                  id="email"
                  type="email"
                  variant="outlined"
                  size="small"
                  placeholder="email"
                  name="email"
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  InputProps={{
                    style: {
                      width: "80%",
                      background: "white",
                      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.4)",
                      marginBottom: "1rem",
                      color: "#17275C",
                    },
                  }}
                />

                <div className="flex flex-row justify-end mb-4 mt-4 mr-28">
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    sx={{ textTransform: "none" }}
                    onClick={handleSubmit}
                    disabled={isSubmit}
                    className="mt-2 mx-20"
                    style={{
                      color: "white",
                      backgroundColor: "#081A51",

                      padding: "8px 16px",
                      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                      width: "120px",
                      height: "35px",
                    }}
                  >
                    {isSubmit ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </div>
            </form>
      
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
